import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';

import { ContentTitle } from '@bo-components/common/styled';
import Form from '@bo-components/common/form/Form';
import FormField from '@bo-components/common/form/FormField';

const DomainInfo = ({ siteBasicInfo, redirectUrlList }) => {
  const redirectUrl = useMemo(
    () => redirectUrlList.map(({ redirectUrl }) => redirectUrl).join(', '),
    [redirectUrlList]
  );
  return (
    <FlexBoxColumn width={'100%'} align-items={'flex-start'}>
      <ContentTitle type={'secondary'} width={'100%'}>
        도메인정보
      </ContentTitle>
      <Spacing bottom={'8px'} />
      <Form>
        <FormField label={'PC도메인'} >
          <TextBox>{siteBasicInfo.sitePcUrl}</TextBox>
        </FormField>
        <FormField label={'카카오톡 채널'} required>
          <TextBox>{siteBasicInfo.kakaoChannelName}</TextBox>
        </FormField>
        <FormField label={'Mobile도메인'} full>
          <TextBox>{siteBasicInfo.siteMobileUrl}</TextBox>
        </FormField>
        <FormField label={'RE-direct도메인'} full>
          <TextBox>{redirectUrl}</TextBox>
        </FormField>
      </Form>
    </FlexBoxColumn>
  );
};

export default DomainInfo;

DomainInfo.propTypes = {
  siteBasicInfo: PropTypes.object,
  redirectUrlList: PropTypes.arrayOf(PropTypes.object),
};
